import React from "react";
import { createRoot } from "react-dom/client";
import { initI18nFromSSR } from "./i18n/initFromSSR";

//init dayjs
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import ProductDetail from "./features/productdetail/ProductDetail";

dayjs.extend(utc);
dayjs.extend(timezone);

// Initialize i18n from SSR data và đợi load xong trước khi render
initI18nFromSSR().then(() => {
  const root = document.getElementById("product-detail-app");
  if (root) {
    // Get the product props from the data attribute
    const productPropsData = root.getAttribute("data-product-props");
    const productSettingsData = root.getAttribute("data-product-settings");

    // Parse the JSON data
    let productProps = null;
    if (productPropsData) {
      try {
        productProps = JSON.parse(productPropsData);
      } catch (error) {
        console.error("Error parsing product props:", error);
      }
    }

    // Parse the JSON data
    let productSettings = null;
    if (productSettingsData) {
      try {
        productSettings = JSON.parse(productSettingsData);
      } catch (error) {
        console.error("Error parsing product settings:", error);
      }
    }

    const activePricePolicyId = root.getAttribute("data-active-price-policy-id");
    const websitePricePolicyId = root.getAttribute(
      "data-website-price-policy-id"
    );

    createRoot(root).render(
      <ProductDetail
        productProps={productProps}
        productSettings={productSettings}
        selectedPricePolicyId={
          activePricePolicyId && activePricePolicyId.length > 0
            ? +activePricePolicyId
            : 0
        }
        websitePricePolicyId={
          websitePricePolicyId && websitePricePolicyId.length > 0
            ? +websitePricePolicyId
            : 0
        }
      />
    );
  }
});
